import React, {useEffect, useState} from 'react';
import {DropdownInput} from './PageSize.style';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {t} from 'i18next';
import {DropdownOptionProps, DropdownSingleValueProps} from '../../models/DropdownProps';

export const PageSize: React.VFC<DropdownSingleValueProps<number>> = (props) => {
    const [pageSizeInput, setPageSizeInput] = useState<number>(props.defaultValue);
    const [pageSizeOptions, setPageSizeOptions] = useState<DropdownOptionProps[]>(props.dataSource);

    useEffect(() => {
        setPageSizeOptions(props.dataSource);
    }, [props.dataSource]);

    useEffect(() => {
        if (props.resetState) {
            setState(props.defaultValue, props.dataSource, true);
        }
    }, [props.resetState]);

    useEffect(() => {
        if (props.defaultValue > 0) {
            let updatedOptions = props.dataSource;
            let pageSize = pageSizeInput;
            if (pageSize == 0) {
                pageSize = props.defaultValue;
                setPageSizeInput(props.defaultValue);
            }
            setState(pageSize, updatedOptions, false);
        }
    }, [props.defaultValue]);

    const setState = (selectionState: number, selectionOptions: DropdownOptionProps[], resetInput: boolean) => {
        props.onChange(selectionState);
        setPageSizeOptions(selectionOptions);
        if (resetInput) {
            setPageSizeInput(props.defaultValue);
        }
    };

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = Number(e.target.value);
        if ((eventValue === undefined) || (!eventValue) || isNaN(eventValue) || (eventValue <= 0)) {
            setPageSizeInput(props.defaultValue);
        } else {
            setPageSizeInput(eventValue);
        }

        let selectionOptions = pageSizeOptions;
        if (props.resetInput) {
            selectionOptions = pageSizeOptions.filter(option => (option.value !== eventValue));
        }
        setState(eventValue, selectionOptions, props.resetInput);
    };

    return (
        <DropdownInput id={generateIdentifier('noOfItems_'.concat(String(pageSizeInput)))}
                       defaultValue={props.defaultValue}
                       aria-label={'ItemsPerPage_'.concat(pageSizeInput.toString())}
                       label={t('ITEMS_PER_PAGE')}
                       value={pageSizeInput}
                       options={pageSizeOptions}
                       onChange={handleInput}/>
    );
};
